export default [
  {
    path: '/expert/unitManage',
    hidden: true,
    component: () => import('@/epp/expertmain/unitmanage/QueryUnit'),
    meta: { title: '专家单位管理' },
  },
  {
    path: '/expert/unitItemManage',
    name: 'unitItemManage',
    component: () => import('@/epp/expertmain/unitmanage/QueryUnitItem'),
    meta: { title: '子单位管理'},
    hidden: true,
  },
  ]
